import * as React from "react";
import {Link} from "react-router-dom";
import {resourcesHelper} from "@ferry/portal-core";
import {getAmountWithDecimalDigits} from "../../../../../../CommonFunctions";

interface IProps {
    interaction: any;
    policyNumber: string;
    payOffAmountWithRemainingInterest?: number;
    remainingInterest?: number;
}

export class AccountBalanceSection extends React.Component<IProps> {

    constructor(props: IProps) {
        super(props);
    }


    public render() {
        const remainingAmountPresent: boolean = Math.abs(this.props.payOffAmountWithRemainingInterest!) !== 0;
        const payOffUrl: string = `/dashboard/${this.props.policyNumber}/payOffBalance`;

        return (
            <div className="account-balance-section">
                <div className="d-flex flex-row">
                    <div className="d-none d-md-flex flex-column">
                        <img className="icon-panel mb-0"
                             src={`/${resourcesHelper.THEME_PATH}/img/account-balance.svg`}
                             alt="Ballance icon" aria-label="Ballance icon"/>
                    </div>
                    <div className="d-flex flex-column justify-c-center">
                        <div className="d-md-none d-flex align-i-center mb-3">
                            <img className="icon-panel mb-0"
                                 src={`/${resourcesHelper.THEME_PATH}/img/account-balance.svg`}
                                 alt="Ballance icon" aria-label="Ballance icon"/>
                            <h2 className="font-family-display font-weight-bold mb-0">
                                Account balance
                            </h2>
                        </div>
                        <div className="d-flex flex-column">
                            <h2 className="font-family-display font-weight-bold d-md-block d-none mb-4">
                                Account balance
                            </h2>
                            <div className="justify-content-center mt-2">
                                <div>
                                    <div id="account-balance" className="mb-3">
                                        <span className="font-weight-bold">-{getAmountWithDecimalDigits(Math.abs(this.props.payOffAmountWithRemainingInterest!))}</span> (incl. Interest and Insurance Premium Tax)
                                    </div>
                                    {remainingAmountPresent && <p className="mb-2">By paying off your car insurance,
                                        you're saving {getAmountWithDecimalDigits(this.props.remainingInterest)} in interest charges. There are no fees on
                                        doing this.</p>
                                    }
                                </div>
                                {
                                    <Link
                                        to={remainingAmountPresent ? payOffUrl : `#`}
                                        id="payOffBalance"
                                    >
                                        <button
                                            className="pay-off-balance btn btn-blue-dashboard mb-0 mt-0"
                                        >
                                            Pay off my balance
                                        </button>
                                    </Link>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
